// components
import Validation from '@/js/components/forms/validation';

class Detail {
  constructor() {
    this.dom = {
      formContact: document.getElementById('form-rental'),
      alertScroll: document.querySelector('.js-alert-scroll:not(.d-none)'),
      arriveDateSelect: document.getElementById('arriveDate'),
      periodSelect: document.getElementById('rentalUnitPeriod'),
      bookPeriodButtons: [...document.querySelectorAll('.js-book-period')],
    };

    this.components = {
      contactFormValidation: null,
    };

    // Every period option, cached so the select can be rebuilt per arrival date
    this.data = {
      periodPlaceholder: null,
      periodOptions: [],
    };

    this.mount();
  }

  mount() {
    if (this.dom.formContact) {
      this.components.contactFormValidation = new Validation(this.dom.formContact);
    }

    if (this.dom.periodSelect) {
      const options = [...this.dom.periodSelect.options];

      this.data.periodPlaceholder = options.find((option) => !option.value) || new Option('', '');
      this.data.periodOptions = options.filter((option) => option.value);
    }

    if (this.dom.arriveDateSelect) {
      this.dom.arriveDateSelect.addEventListener('change', () => this.filterPeriods());

      // Respect a period that was kept selected after an invalid submit
      this.filterPeriods(this.dom.periodSelect ? this.dom.periodSelect.value : null);
    }

    if (this.dom.alertScroll) {
      this.dom.alertScroll.scrollIntoView({ behavior: 'smooth' });
    }

    // "Boek nu" next to a period preselects that arrival date and period
    this.dom.bookPeriodButtons.forEach((button) => button.addEventListener('click', () => {
      this.selectPeriod(button.dataset.startDate, button.dataset.periodId);
    }));
  }

  /**
   * limit the period options to the periods starting on the chosen arrival date
   * @param periodId {String|null} period to select afterwards, when still available
   */
  filterPeriods(periodId = null) {
    const { arriveDateSelect, periodSelect } = this.dom;

    if (!periodSelect) return;

    const startDate = arriveDateSelect ? arriveDateSelect.value : '';
    const options = this.data.periodOptions.filter((option) => !startDate || option.dataset.startDate === startDate);

    periodSelect.replaceChildren(this.data.periodPlaceholder, ...options);

    if (periodId && options.some((option) => option.value === periodId)) {
      periodSelect.value = periodId;
    } else {
      // A single duration needs no choosing
      periodSelect.value = options.length === 1 ? options[0].value : '';
    }

    // let the validation component clear a previous invalid state on the field
    periodSelect.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * preselect an arrival date and its period in the reservation form
   * @param startDate {String}
   * @param periodId {String}
   */
  selectPeriod(startDate, periodId) {
    const { arriveDateSelect } = this.dom;

    if (arriveDateSelect && startDate) {
      arriveDateSelect.value = startDate;
      arriveDateSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }

    this.filterPeriods(periodId);
  }
}

if (document.getElementById('page-holiday-rental-detail')) {
  // eslint-disable-next-line no-new
  new Detail();
}
